import React from "react";
import useReportTasks from "components/pages/transmissions/modal/detail/notes/task/useReportTasks";

import { Button, OutlinedInput } from "@mui/material";

import {
  cancelReportTask,
  onReportTaskInputFocus,
} from "app/store/transmission/slice/transmissionSlice";

const ReportTaskForm = ({
  data,
  isFetching,
  task,
  handleInputChange,
  onSubmit,
  onCancel,
}) => {
  const {
    isArchiveReport,
    taskSubmitting,
    taskFocused,
    isEditReportTask,
    theme,
    dispatch,
  } = useReportTasks(data);

  return (
    !data?.legacy &&
    !isArchiveReport && (
      <div className="view-pdf__notes-content">
        <OutlinedInput
          rows={3}
          multiline
          fullWidth
          className="view-pdf__notes-content--textarea"
          variant="outlined"
          id="standard-basic"
          placeholder="Add task description"
          value={task?.description || ""}
          onChange={(event) => handleInputChange(event.target.value)}
          onFocus={() => dispatch(onReportTaskInputFocus(true))}
          style={{
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.background.paper,
          }}
        />
        {taskFocused && (
          <div className="view-pdf__button-container d-flex flex-column">
            <Button
              onClick={() => onSubmit(false)}
              className="view-pdf__button mb-2"
              variant="contained"
              color="secondary"
              disabled={
                !taskFocused ||
                !task?.description?.trim() ||
                isFetching ||
                taskSubmitting ||
                data?.legacy
              }
            >
              <span style={{ color: "white" }}>
                {taskSubmitting
                  ? "Adding..."
                  : isEditReportTask
                    ? "Update"
                    : "Add"}
              </span>
            </Button>
            <Button
              onClick={() => {
                onCancel();
                dispatch(cancelReportTask({ focused: false }));
              }}
              className="view-pdf__button"
              variant="outlined"
              disabled={taskSubmitting}
              color="secondary"
            >
              Cancel
            </Button>
          </div>
        )}
      </div>
    )
  );
};

export default ReportTaskForm;
